import { Component, AfterViewInit, ElementRef, ViewChild, Input } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';
import { Router } from '@angular/router';
import { UserAtividadeService } from '../shared/user-atividade/user-atividade.service';
import { Chart, ChartType, registerables } from 'chart.js';
import { DashboardService } from '../shared/dashboard/dashboard.service';
import { Item1 } from '../shared/dashboard/item.model';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {

  constructor(public authService: AuthService,
    private router: Router,
    public userAtividadeService: UserAtividadeService,
    private dashboardService: DashboardService) { }

  isVisivel = false;
  total: number = 0;
  terreno: number = 0;
  online: number = 0;
  terrenoPerc: number = 0;
  onlinePerc: number = 0;

  async ngOnInit() {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }

    if (!this.authService.hasRoles(['ADMIN','MANAGER'])) {
      this.router.navigate(['/']);
    }

    const email = this.authService.getEmail();

    if (email !== null) {
      this.userAtividadeService.getUserActivity(email).subscribe({
        error: err => {
          if (err.status === 401) {
            this.authService.showSessionExpiredAlert();
          }
        }
      });
    }

    if (Capacitor.getPlatform() !== 'web') {
      this.isVisivel = true
    }

    this.dashboardService.getTotalByPaisResidencia().subscribe({
      next: (result) => {
        const labels = result.map(item => item.value);
        const data = result.map(item => item.total);
        const backgroundColor = this.generateColorPalette(labels.length);
        const ctx = document.getElementById('myChart1') as HTMLCanvasElement;
        this.loadLineAreahart(ctx, labels, data, backgroundColor)
      },
      error: (err) => {
        console.error('Erro ao buscar dados do gráfico', err);
      }
    });

    this.dashboardService.getBytTipoRecolha().subscribe({
      next: (result) => {
        this.total = result.terreno + result.online
        this.terreno = result.terreno
        this.online = result.online
        this.terrenoPerc = (this.terreno / this.total) * 100;
        this.onlinePerc = (this.online / this.total) * 100;
      },
      error: (err) => {
        console.error('Erro ao buscar dados do gráfico', err);
      }
    });

    this.dashboardService.getByCountryCode().subscribe({
      next: (result) => {
        const labels = result.map(item => item.value);
        const data = result.map(item => item.total);
        const backgroundColor = this.generateColorPalette(labels.length);
        const ctx = document.getElementById('myChart2') as HTMLCanvasElement;
        this.loadDoughnutChart(ctx, labels, data, backgroundColor)
      },
      error: (err) => {
        console.error('Erro ao buscar dados do gráfico', err);
      }
    });    
  }

  formatarMilhar(n: number): string {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  generateColorPalette(count: number): string[] {
    const paletteBase = ["#9cabff", "#b8acff", "#7de1f8"];
    const colors: string[] = [];
    for (let i = 0; i < count; i++) {
      const base = paletteBase[i % paletteBase.length];
      const alpha = 0.5 + ((i % 5) * 0.1);
      const rgba = this.hexToRgba(base, alpha);
      colors.push(rgba);
    }
    return colors;
  }

  hexToRgba(hex: string, alpha: number): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha.toFixed(2)})`;
  }

  loadDoughnutChart(ctx: HTMLCanvasElement, labels: string[], data: number[], backgroundColor: string[]): void {
    Chart.register(...registerables);
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [{
          label: 'Inquéritos',
          data: data,
          backgroundColor: backgroundColor,
          borderWidth: 1
        }]
      },
      options: {
        plugins: {
          legend: {
            labels: {
              boxWidth: 12,
              padding: 20,
              color: '#6783b8',
            }
          },
          tooltip: {
            enabled: true,
            backgroundColor: '#fff',
            borderColor: '#eff6ff',
            borderWidth: 2,
            titleFont: {
              size: 13,
            },
            titleColor: '#6783b8',
            titleMarginBottom: 6,
            bodyColor: '#9eaecf',
            bodyFont: {
              size: 12
            },
            bodySpacing: 4,
            padding: 10,
            footerMarginTop: 0,
            displayColors: false
          },
        },
        rotation: -1.5,
        maintainAspectRatio: false,
      }

    });
  }

  loadLineAreahart(ctx: HTMLCanvasElement, labels: string[], data: number[], backgroundColor: string[]): void {
    Chart.register(...registerables);
    new Chart(ctx, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: 'Inquéritos',
          data: data,
          fill: true,
          backgroundColor: backgroundColor,
          borderWidth: 1
        }]
      },
      options: {
        plugins: {
          legend: {
            labels: {
              boxWidth: 12,
              padding: 20,
              color: '#6783b8',
            }
          },
          tooltip: {
            enabled: true,
            backgroundColor: '#fff',
            borderColor: '#eff6ff',
            borderWidth: 2,
            titleFont: {
              size: 13,
            },
            titleColor: '#6783b8',
            titleMarginBottom: 6,
            bodyColor: '#9eaecf',
            bodyFont: {
              size: 12
            },
            bodySpacing: 4,
            padding: 10,
            footerMarginTop: 0,
            displayColors: false
          },
        },
        maintainAspectRatio: false,
      }
    });
  }
}

